import { apiClient } from './client';
import {
  User,
  UserFilter,
  UserCreateRequest,
  UserUpdateRequest,
  UserListResponse,
} from '../types/user';

export interface UserProfile {
  id: string;
  email: string;
  given_name: string;
  family_name: string;
  display_name: string;
  tenant_id: string;
  role: string;
  created_at: string;
  updated_at: string;
}

export interface UserStats {
  licenses: {
    total: number;
    active: number;
    inactive: number;
  };
  devices: {
    total: number;
    active: number;
    inactive: number;
  };
  applications: {
    total: number;
  };
}

export interface UpdateProfileRequest {
  given_name: string;
  family_name: string;
}

export const userApi = {
  getUsers: async (filter: UserFilter) => {
    const response = await apiClient.get<UserListResponse>('/users', { params: filter });
    return response.data;
  },

  getUser: async (id: string) => {
    const response = await apiClient.get<User>(`/users/${id}`);
    return response.data;
  },

  createUser: async (data: UserCreateRequest) => {
    const response = await apiClient.post<User>('/users', data);
    return response.data;
  },

  updateUser: async (id: string, data: UserUpdateRequest) => {
    const response = await apiClient.put<User>(`/users/${id}`, data);
    return response.data;
  },

  deleteUser: async (id: string) => {
    await apiClient.delete(`/users/${id}`);
  },

  // ライセンス作成用：role=USERのユーザー一覧を取得
  getUsersForLicense: async () => {
    const response = await apiClient.get<UserListResponse>('/users', {
      params: { role: 'USER' }
    });
    return response.data.users || [];
  },

  // プロフィール管理関連
  getProfile: async (): Promise<UserProfile> => {
    const response = await apiClient.get<UserProfile>('/api/profile');
    return response.data;
  },

  updateProfile: async (data: UpdateProfileRequest): Promise<UserProfile> => {
    const response = await apiClient.put<UserProfile>('/api/profile', data);
    return response.data;
  },

  getStats: async (): Promise<UserStats> => {
    const response = await apiClient.get<UserStats>('/api/stats');
    return response.data;
  }
};

// 後方互換性のためのエクスポート
export const getUserProfile = userApi.getProfile;
export const updateUserProfile = userApi.updateProfile;
export const getUserStats = userApi.getStats; 